import React, { useState } from 'react'
import { useEffect } from 'react'
import { getTime } from '..'
import style from './time.module.scss'

function Time() {


    
    const [curTime, setCurTime] = useState(getTime())
    const {hh, mm, ss, day, month, year} = curTime

    useEffect(() => {   

        const interval = setInterval(() => {
            setCurTime(getTime())
        }, 1000)

        return () => clearInterval(interval)
    }, [])

  return (
    <div className={style.container}>
        
        <div className= {style.timeContainer}>
            <div className={style.box}>{hh}</div> 
            <div className={style.box}>{mm}</div> 
            <div className={style.box}>{ss}</div>
        </div>
        <div className={style.dateContainer}>
            <div>{day}</div>
            <div>{month}</div>
            <div>{year}</div>
        </div>

    </div>
  )
}

export default Time